/**
 * Utility function to get a random MED- image from the public/images directory
 * @returns Path to a randomly selected MED- image
 */
export const getRandomMedImage = (): string => {
  const medImages = [
    "/images/MED-3.jpg",
    "/images/MED-4.jpg",
    "/images/MED-8.jpg",
    "/images/MED-8 (1).jpg",
    "/images/MED-9.jpg",
    "/images/MED-10.jpg",
    "/images/MED-10 (1).jpg",
    "/images/MED-31.jpeg",
    "/images/MED-40.jpg",
    "/images/MED-42.jpg",
    "/images/MED-44.png",
    "/images/MED-45.jpg",
    "/images/MED-47.jpg",
    "/images/MED-48.jpg"
  ];
  
  const randomIndex = Math.floor(Math.random() * medImages.length);
  return medImages[randomIndex];
};